import { render, staticRenderFns } from "./HaveAQuestion.vue?vue&type=template&id=38b82d24&scoped=true&"
import script from "./HaveAQuestion.vue?vue&type=script&lang=js&"
export * from "./HaveAQuestion.vue?vue&type=script&lang=js&"
import style0 from "./HaveAQuestion.vue?vue&type=style&index=0&id=38b82d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b82d24",
  null
  
)

export default component.exports